<template>
  <div class="col-md-12 projects_list">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="form_select">
          <label> {{ translate("project.status") }} </label>
          <tree-select
              :options="status_list"
              :multiple="false"
              v-model="filter.status"
              :placeholder="translate('project.status')"
              :clearable="false"
          />
        </div>

        <div class="form_select">
          <label> {{ translate("project.priority") }} </label>
          <tree-select
              :options="priority_list"
              :multiple="false"
              v-model="filter.priority"
              :placeholder="translate('project.priority')"
              :clearable="false"
          />
        </div>

        <div class="filter checkbox">
          <div class="info">
            {{ translate('project.only_my') }}
          </div>
          <label class="switch" @click.prevent="filter.only_my = !filter.only_my">
            <input type="checkbox" v-model="filter.only_my">
            <span class="slider round"></span>
          </label>
        </div>

        <span
            v-if="$store.getters.getPermissions.createProject === true"
            class="mdi mdi-plus-circle-outline btn btn-success btn-fill"
            @click.prevent="add_project"
        >
        <b>{{ translate('project.to_add') }}</b>
      </span>
      </div>
    </div>

    <div class="response_table">
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th scope="col" class="name">
              {{ translate('project.client') }}
            </th>
            <th scope="col" class="name">
              {{ translate('project.name') }}
            </th>
            <th scope="col" class="name">
              {{ translate('project.description') }}
            </th>
            <th scope="col" class="w180">
              {{ translate('project.status') }}
            </th>
            <th scope="col" class="w180">
              {{ translate('project.priority') }}
            </th>
            <th scope="col" class="w100">
              {{ translate('project.updated') }}
            </th>

          </tr>
        </thead>
        <tbody>
          <ProjectListItem
              v-for="(project,key) in projects_list"
              :key="key"
              :project="project"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ProjectListItem from "@/views/Dashboard/General/ProjectList/Item/Index.vue";
import ProjectModal from "@/views/Dashboard/General/ProjectList/Modal/Index.vue";

export default {
  name: 'Projects',
  components: {
    ProjectListItem
  },
  data () {
    return {
      projects_list: {},
      project_statuses: [],
      project_prioritys: [],
      searched_projects: '',
      check_link: true,
      filter:{
        only_my: true,
        status: -1,
        priority: -1
      },
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  computed:{
    status_list(){
      let list = [{id: -1, label: 'All statuses'}]
      let statuses = this.$store.getters.getProjectInfo.statuses.map((entry) => {
        return {id: entry.id, label: entry.title}
      })
      return list.concat(statuses)
    },

    priority_list(){
      let list = [{id: -1, label: 'All priorities'}]
      let priorities = this.$store.getters.getProjectInfo.prioritys.map((entry) => {
        return {id: entry.id, label: entry.title}
      })
      return list.concat(priorities)
    },
  },

  watch:{
    filter:{
      deep: true,
      handler(){
        this.load_projects()
      }
    }
  },

  activated () {
    this.load_projects()
  },

  deactivated() {
    this.$modal.hide('project_modal')
  },

  destroyed() {
    this.$modal.hide('project_modal')
  },

  methods: {
    load_projects(){
      this.$http.v1.getProjects(this.filter, (response) => {
        if (response.data){
          this.projects_list = response.data.projects
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
    add_project() {
      let t = this.$createElement(ProjectModal, {
        props: {},
        on: {
          close: () => {
            this.$modal.hide('project_modal')
            this.check_link = true
          },
          update: (project_id) => {
            this.load_projects()
            this.$modal.hide('project_modal')
            this.$router.push('/project/' + project_id)
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        width: 800,
        adaptive: true,
        clickToClose: true,
        name: 'project_modal'
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    }
  }
}
</script>

<style lang="scss" scoped>

.projects_list{
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  .main_filters{
    top: 20px;
  }
  .header{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex: 1;
    & > *{
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
    }
    .filter{
      margin: 0;
    }
    .form{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 2;

      .search_user{
        margin-bottom: 0;
        width: 100%;
      }
      .btn{
        width: 30%;
      }
    }
    .form_select{
      flex: 1;
      .vue-treeselect{
        margin-bottom: 0;
      }
    }
  }

  .project{
    cursor: pointer;
    &:hover{
      background-color: #eee;
    }
    td{
      overflow: hidden;
    }
  }
  .response_table{
    flex: 10;
    padding-left: 0;
    padding-right: 0;

    .level{
      display: inline-block;
      width: 20px;
      height: 100%;
    }
    .w180{
      max-width: 180px;
      width: 180px;
    }
    .w100{
      max-width: 100px;
      width: 100px;
    }
    .has_child{
      background-color: #eee;
      font-weight: bold;
    }
    .name{
      text-align: left;
    }
    .inn{
      text-align: left;
    }
  }
}

@media (max-width: 1200px) {
  .projects_list{
    .response_table{
      .w180{
        max-width: none;
        width: auto;
      }
      .w100{
        max-width: none;
        width: auto;
      }
    }
  }
}

@media (max-width: 500px){
  .header{
    .form{
      width: 100%;
      .filter{
        min-width: max-content;
        margin: 0 10px;
      }
    }
    .btn{
      b{
        display: none;
      }
      width: 20%;
      min-width: inherit;
    }
    .search_user{
      width: 80%;
    }
  }

}
</style>
